import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["contents"];

  connect() {
    if (!this.hasContentsTarget) return;
    if (this.hasResult()) return;
    if (this._pollingId) clearInterval(this._pollingId);

    this._pollingId = setInterval(() => {
      if (this.hasResult()) {
        clearInterval(this._pollingId);
        this._pollingId = null;
        return;
      }
      if (this.contentsTarget) {
        const src = this.contentsTarget.getAttribute("src") || this.contentsTarget.src;
        if (src) {
          const url = new URL(src, window.location.origin);
          url.searchParams.set("polling", "1");
          this.contentsTarget.src = url.toString();
        }
      }
    }, 2000);
  }

  disconnect() {
    if (this._pollingId) {
      clearInterval(this._pollingId);
      this._pollingId = null;
    }
  }

  hasResult() {
    return !!(
      this.hasContentsTarget &&
      this.contentsTarget.querySelector(".mypage-profile-result")
    );
  }
}
